/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SiteSerie } from "../../models/http/data-centers/data-centers-site-serie.model";
import { MetricOverviewResponse } from "../../models/http/data-centers/data-centers-metric-overview-response.model";
import { SiteMetric } from "../../models/http/data-centers/data-centers-site-metric.model";
import { HttpMethods } from "../../models/ui/http-methods.model";
import { ENDPOINT_GROUPS } from "../../utils/apis/apis.constants";
import { CommunicationService } from "../communication.service";
import { StorageService } from "../storage.service";

@Injectable({
	providedIn: "root"
})
export class DashboardDataCentersHttpService {
	private _dashboardDataCentersOperations = ENDPOINT_GROUPS.dashboardDataCenters.operations;

	constructor(
		private _communicationService: CommunicationService,
		private _storageService: StorageService
	) {}

	public getUserSiteList(): Observable<SiteSerie> {
		const params = new HttpParams({
			fromObject: {
				tenantId: this._storageService.getTenantId()
			}
		});

		return this._communicationService.callService(
			this._dashboardDataCentersOperations.getUserSiteList.service,
			HttpMethods.GET,
			{ params }
		);
	}

	public getMetricOverview(): Observable<MetricOverviewResponse> {
		const params = new HttpParams({
			fromObject: {
				tenantId: this._storageService.getTenantId()
			}
		});

		return this._communicationService.callService(
			this._dashboardDataCentersOperations.getMetricOverview.service,
			HttpMethods.GET,
			{ params }
		);
	}

	public getUserSiteMetricData(siteId: number): Observable<SiteMetric[]> {
		const params = new HttpParams({
			fromObject: {
				tenantId: this._storageService.getTenantId(),
				siteId
			}
		});

		return this._communicationService.callService(
			this._dashboardDataCentersOperations.getUserSiteMetricData.service,
			HttpMethods.GET,
			{ params }
		);
	}
}
